var fn = function( obj ){
var __t,__p='';
__p+='precision lowp float;\n\nattribute vec2 aPosition;\n\nuniform mat4 uUnproject;\n\nvarying lowp vec3 vTexCoord;\n\nvoid main( void ){\n  vec4 pos = vec4( aPosition, .5, 1.0 );\n  vTexCoord = normalize( (uUnproject * pos).xyz );\n  gl_Position = pos;\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;